export default function CostFinance() {
  return (
    <section id="cost-finance" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#444c42] mb-6">
            IMPLANT COST & FINANCE OPTIONS
          </h2>
          <p className="text-lg text-[#7A8178] max-w-3xl mx-auto">
            Affordable dental implants with flexible payment plans to suit your budget
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div className="bg-gradient-to-br from-[#D0A24F] to-[#F5d383] p-8 rounded-2xl shadow-xl text-white text-center">
            <i className="ri-hand-coin-line text-5xl mb-4"></i>
            <h3 className="text-2xl font-bold mb-2">Flexible Payment Plans</h3>
            <p className="text-base">Spread the cost over time with our flexible payment options</p>
          </div>

          <div className="bg-gradient-to-br from-[#444c42] to-[#7A8178] p-8 rounded-2xl shadow-xl text-white text-center">
            <i className="ri-percent-line text-5xl mb-4"></i>
            <h3 className="text-2xl font-bold mb-2">0% Finance Available</h3>
            <p className="text-base">Interest-free finance options to make treatment affordable</p>
          </div>

          <div className="bg-gradient-to-br from-[#D0A24F] to-[#F5d383] p-8 rounded-2xl shadow-xl text-white text-center">
            <i className="ri-file-list-3-line text-5xl mb-4"></i>
            <h3 className="text-2xl font-bold mb-2">Transparent Pricing</h3>
            <p className="text-base">Clear, upfront pricing with detailed treatment plans</p>
          </div>

          <div className="bg-gradient-to-br from-[#444c42] to-[#7A8178] p-8 rounded-2xl shadow-xl text-white text-center">
            <i className="ri-shield-check-line text-5xl mb-4"></i>
            <h3 className="text-2xl font-bold mb-2">No Hidden Fees</h3>
            <p className="text-base">What we quote is what you pay - guaranteed</p>
          </div>
        </div>

        <div className="bg-[#D0A24F]/10 p-8 rounded-2xl border-l-4 border-[#D0A24F] text-center">
          <p className="text-lg text-[#444c42] mb-6">
            <strong>Book your FREE consultation</strong> to receive a personalized treatment plan and detailed cost breakdown
          </p>
          <button
            onClick={() => {
              const element = document.getElementById('booking');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="bg-[#D0A24F] text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-[#F5d383] transition-all transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
          >
            Get Your Free Quote
          </button>
        </div>
      </div>
    </section>
  );
}
